import { ChatDots } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UserNotes = ({ notes }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <ChatDots />
      <Text type="bodyMRegular" color={theme.colors.accent.on}>
        &quot;{notes}&quot;
      </Text>
    </Styles.Container>
  )
}

export default UserNotes
